import React, { useRef } from "react";
import { Select } from "@opendate-app/setlist";

import "../styles/fanFilterSelect.css";

export const FAN_FILTER_SELECT_WIDTH = "100%";

let nextSelectNumber = 0;

const FanFilterSelect = ({ width = FAN_FILTER_SELECT_WIDTH, ...props }) => {
  const idRef = useRef(null);
  if (idRef.current === null) {
    nextSelectNumber += 1;
    idRef.current = `fan-filter-select-${nextSelectNumber}`;
  }

  return <Select id={idRef.current} className="fan-filter-select" width={width} {...props} />;
};

export default FanFilterSelect;
